import { useTranslation } from 'react-i18next'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import SearchIcon from '@mui/icons-material/Search'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import DownloadingIcon from '@mui/icons-material/Downloading'
import { useLocation } from 'react-router-dom'
import { financialReportListTypeFilter, financialReportType } from '../constant'
import Select from 'react-dropdown-select'

export const FinancialReportFilters = ({ data, methods }) => {
    const weekListOptions = [
        { name: 'Week', value: 'WEEK' },
        { name: 'Month', value: 'MONTH' },
        { name: 'Year', value: 'YEAR' },
    ]

    const listTypeOptions = [
        { name: 'All', value: 'ALL' },
        { name: 'Event', value: 'EVENT' },
        { name: 'Service', value: 'SERVICE' },
    ]
    const { t } = useTranslation()
    const { filterInputs, vendorListData } = data
    const { handleFilterInputChange, reset, search, getUserReport } = methods
    const btnClass = 'custom_button bg-green-color white-color ms-3 d-flex justify-content-around align-items-center'
    const location = useLocation()
    const pathSegments = location.pathname.split('/').filter(Boolean)
    const lastSegment = pathSegments[pathSegments.length - 1]

    return (
        <div className="row mt-2 w-100">
            <div className="col-md-2 col-sm-6 col-12">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={'Start Date'}
                        value={filterInputs?.startDate || null}
                        onChange={(newValue) => handleFilterInputChange('startDate', newValue)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                </LocalizationProvider>
            </div>
            <div className="col-md-2 col-sm-6 col-12">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={'End Date'}
                        value={filterInputs?.endDate || null}
                        onChange={(newValue) => handleFilterInputChange('endDate', newValue)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                </LocalizationProvider>
            </div>
            {financialReportListTypeFilter.includes(lastSegment) ? (
                <div className="col-md-2 col-sm-6 col-12">
                    <Select
                        searchable={true}
                        multi={false}
                        options={listTypeOptions}
                        onChange={(newValue) => handleFilterInputChange('listType', newValue)}
                        searchBy="name"
                        labelField="name"
                        values={filterInputs?.listType ? [filterInputs?.listType] : []}
                        name="listType"
                        valueField="value"
                        className="font-11"
                    />
                </div>
            ) : null}
            {financialReportType.includes(lastSegment) ? (
                <div className="col-md-2 col-sm-6 col-12">
                    <Select
                        searchable={true}
                        multi={false}
                        options={vendorListData}
                        onChange={(newValue) => handleFilterInputChange('vendor_id', newValue)}
                        searchBy="fullName"
                        placeholder="Vendor"
                        labelField="fullName"
                        values={filterInputs?.vendor_id ? [filterInputs?.vendor_id] : []}
                        name="vendor_id"
                        valueField="_id"
                        className="font-11"
                    />
                </div>
            ) : null}
            {lastSegment === financialReportType[5] ? (
                <div className="col-md-2 col-sm-6 col-12">
                    <Select
                        searchable={true}
                        multi={false}
                        options={weekListOptions}
                        onChange={(newValue) => handleFilterInputChange('filter', newValue)}
                        searchBy="name"
                        labelField="name"
                        values={filterInputs?.filter ? [filterInputs?.filter] : []}
                        name="filter"
                        valueField="value"
                        className="font-11"
                    />
                </div>
            ) : null}
            <div className="col-sm-4 col-12 d-flex">
                <button className={`${btnClass} bg-green-color`} onClick={search}>
                    <SearchIcon size={20} className="me-1" />
                    <span className="me-1">{t('buttonTitle.search')}</span>
                </button>
                <button className={`${btnClass} bg-blue-color`} onClick={reset}>
                    <RestartAltIcon size={20} className="me-1" />
                    <span className="me-1">{t('buttonTitle.reset')}</span>
                </button>
                <button className={`${btnClass} bg-blue-color`} onClick={() => getUserReport(true)}>
                    <DownloadingIcon size={20} className="me-1" />
                    <span className="me-1">{t('buttonTitle.download')}</span>
                </button>
            </div>
        </div>
    )
}
